<template>
    <div class="list-page-wrap">
        <transition name="fade" mode="out-in">
            <div>
                <div class="from_design">
                    <el-form :inline="true" :model="formInline" ref="formInline" class="demo-form-inline bg-color"
                        size="mini" @submit.native.prevent="onSubmit">
                        <el-form-item label="" prop="managed_run_number">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">运行ID</div>
                                </div>
                                <div class="append">
                                    <el-input v-model="formInline.managed_run_number" placeholder="精准查询" style="width: 120px"
                                        clearable @keyup.enter.native="onSubmit"></el-input>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="managed_number">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">规则ID</div>
                                </div>
                                <div class="append">
                                    <el-input v-model="formInline.managed_number" placeholder="精准查询" style="width: 120px"
                                        clearable @keyup.enter.native="onSubmit"></el-input>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="" prop="managed_name">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">规则名称</div>
                                </div>
                                <div class="append">
                                    <el-input v-model="formInline.managed_name" placeholder="请输入关键字查询" style="width: 140px"
                                        clearable @keyup.enter.native="onSubmit"></el-input>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="plat_id">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">媒体</div>
                                </div>
                                <div class="append">
                                    <SelectAll :options="allowedPlatList" v-model="formInline.plat_id"/>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="user_id">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">创建人</div>
                                </div>
                                <div class="append">
                                    <SelectAll :options="userList" v-model="formInline.user_id"/>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="group_id">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">创建人部门</div>
                                </div>
                                <div class="append">
                                    <cascader-all
                                    :options="groupList"
                                    :width="200"
                                    :lineHeight="28"
                                    v-model="formInline.group_id"
                                    @change="(val)=>handleGroupId(val)"
                                    clearable
                                    ref="cascaderAall"
                                    />
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item label="" prop="range_time">
                            <div class="clever-form-item">
                                <div class="prefix">
                                    <div class="text">运行时间</div>
                                </div>
                                <div class="append">
                                    <el-date-picker v-model="formInline.range_time" type="daterange" align="right" unlink-panels
                                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                        :picker-options="basePickerOptions" value-format="yyyy-MM-dd" :clearable="false"
                                        style="width: 240px">
                                    </el-date-picker>
                                </div>
                            </div>
                        </el-form-item>


                        <el-divider class="mt10 mb0" />
                        <el-form-item class="">
                            <el-button v-matomo="{behaviorCategory: '智能托管(运行记录)',  name: `筛选(查询)` }" type="primary" @click="onSubmit" :loading="loading">查询</el-button>
                            <el-button v-matomo="{behaviorCategory: '智能托管(运行记录)',  name: `筛选(清空筛选)` }" @click="resetForm('formInline', true)">清空筛选</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="bg-white pt10 pl10 pr10 pb10 mt10 borderRadius5">
                    <jt-table :data="tableData" style="width: 100%" stripe
                        :header-cell-style="{ background: '#e8eaec', color: '#333' }" size="mini" class="create_list"
                         v-loading="loading" tooltip-effect="dark">
                        <el-table-column label="规则名称" min-width="180" prop="managed_number" fixed="left">
                            <template v-slot="scope">
                                <MullineEllips :text="scope.row.managed_name" :lines="2" />
                            </template>
                        </el-table-column>
                        <el-table-column label="触发记录" min-width="160" prop="trigger_record_num">
                            <template v-slot="scope">
                                <span v-if="scope.row.trigger_record_num == 0 || scope.row.trigger_record_num == ''" :style="{color: '#f56c6c'}">未触发</span>
                                <span v-else v-matomo="{behaviorCategory: '智能托管(运行记录)',  name: `列表(触发记录点击)` }" @click="handleRunPush(scope.row, 'TriggerRecordPage', scope.row.trigger_record_num)" :style="{color: '#409EFF', cursor: 'pointer'}">{{ scope.row.trigger_record_num }}条数据触发>></span>
                            </template>
                        </el-table-column>
                        <el-table-column label="媒体" min-width="100" prop="plat_name">
                            <template v-slot="scope">
                                <span>{{ scope.row.plat_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="目标维度" min-width="100" prop="dimension">
                            <template v-slot="scope">
                                <span>{{ scope.row.dimension }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="维度筛选" prop="dimension_config" min-width="180">
                            <template v-slot="scope">
                                <span>{{ scope.row.dimension_config }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="触发操作" prop="trigger_action" min-width="120">
                            <template v-slot="scope">
                                <span>{{ scope.row.trigger_action }}</span>
                                <HoverEllipsisTips :text="scope.row.trigger_action_text || '-'" />
                            </template>
                        </el-table-column>
                        <el-table-column label="检查频次" min-width="120" prop="check_frequency">
                            <template v-slot="scope">
<!--                                <span>{{ scope.row.check_frequency_time }}</span>-->
                                <MullineEllips :text="scope.row.check_frequency_time" :lines="2" />
                            </template>
                        </el-table-column>
                        <el-table-column label="运行时间" min-width="90" prop="create_time">
                            <template v-slot="scope">
                                <span>{{ scope.row.create_time }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建人" min-width="100" prop="c_user_name">
                            <template v-slot="scope">
                                <span>{{ scope.row.creator }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="运行ID" min-width="100" prop="managed_run_number">
                            <template v-slot="scope">
                                <span>{{ scope.row.managed_run_number }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="规则ID" width="100" prop="managed_number">
                            <template v-slot="scope">
                                <span>{{ scope.row.managed_number }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="运行详情" width="100" prop="run_detail">
                            <template v-slot="scope">
                                <span v-matomo="{behaviorCategory: '智能托管(运行记录)',  name: `列表(运行详情)` }" @click="showRunDetail(scope.row)" class="pointer text-color-primary">详情</span>
                            </template>
                        </el-table-column>

                    </jt-table>
                    <div class="tar pt20 pr20">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="[30, 50, 100]" :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import MullineEllips from '@/components/MullineEllips';
import CascaderAll from '../components/cascaderAll';
import SelectAll from '../components/selectAll.vue';
import API from '@/api/intelligent/intelligentManaged/index.js';
import dayjs from "dayjs";
import {runRecordDetailModal} from './modal/index';
import HoverEllipsisTips from "@/components/TextEllips/index.vue";

export default {
    name: "RunRecordPage",    // 智能投放/智能托管/运行记录
    components: {
        MullineEllips,
        CascaderAll,
        SelectAll,
        HoverEllipsisTips
    },
    props:{
        allowedPlatList:Array,
        query:{
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            basePickerOptions: {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [
                    {
                        text: '最近7天',
                        onClick(picker) {
                            const date = new Date();
                            let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
                            let endDate = new Date(date.getTime());
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上周',
                        onClick(picker) {
                            // 上周：自然周，周一到周日
                            let date = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 7);
                            let weekDay = date.getDay();
                            let startDate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * (weekDay === 0 ? 6 : weekDay - 1));
                            let endDate = new Date(startDate.getTime() + 1000 * 60 * 60 * 24 * 6);
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '本月',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;
                            let day = date.getDate();
                            let startDate = year + '-' + month + '-1';
                            let endDate = year + '-' + month + '-' + day;
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            let startDate = new Date(year + '-' + month + '-01');
                            let endDate = new Date(new Date(year + '-' + (month + 1) + '-01').getTime() - 1000 * 60 * 60 * 24);
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '本季度',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;
                            let day = date.getDate();
                            let startDate = '';
                            if ([1, 2, 3].includes(month)) {
                                startDate = year + '-01-01';
                            } else if ([4, 5, 6].includes(month)) {
                                startDate = year + '-04-01';
                            } else if ([7, 8, 9].includes(month)) {
                                startDate = year + '-07-01';
                            } else if ([10, 11, 12].includes(month)) {
                                startDate = year + '-10-01';
                            }
                            let endDate = year + '-' + month + '-' + day;
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '上季度',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;

                            let startDate = '';
                            let endDate = '';
                            if ([1, 2, 3].includes(month)) {
                                startDate = (year - 1) + '-10-01';
                                endDate = (year - 1) + '-12-31';
                            } else if ([4, 5, 6].includes(month)) {
                                startDate = year + '-01-01';
                                endDate = year + '-03-31';
                            } else if ([7, 8, 9].includes(month)) {
                                startDate = year + '-04-01';
                                endDate = year + '-06-30';
                            } else if ([10, 11, 12].includes(month)) {
                                startDate = year + '-07-01';
                                endDate = year + '-09-30';
                            }
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '今年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear();
                            let startDate = year + '-01-01';
                            let endDate = year + '-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    },
                    {
                        text: '去年',
                        onClick(picker) {
                            let date = new Date();
                            let year = date.getFullYear() - 1;
                            let startDate = year + '-01-01';
                            let endDate = year + '-12-31';
                            picker.$emit('pick', [startDate, endDate]);
                        }
                    }
                ]
            },
            userList: [],
            groupList: [],
            formInline: {
                managed_run_number: "",        //运行ID
                managed_number: "",     //规则ID
                managed_name: "",       //规则名称
                plat_id: [],            //媒体
                user_id: [],            //创建人
                group_id: [],           //创建人部门
                range_time: [dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")],         //触发时间区间  20240529/20240529
            },
            tableData: [],
            loading: false,  // 表格loading
            currentPage: 1,
            pageSize: 30,
            total: 10,
        }
    },
    mounted() {
        this.fetchOptions('user', 'userList')
        this.fetchOptions('group', 'groupList')
        if(Object.keys(this.query).length != 0) {
            if(this.query['id'] != '') {
                this.formInline.managed_number = this.query['id']
                if(this.query['ctime']) {
                    let res_rang_time = dayjs(this.query['ctime']).format("YYYY-MM-DD")
                    this.formInline.range_time = [res_rang_time, dayjs().format("YYYY-MM-DD")]
                }
            }
        }
        console.log('结果', this.formInline)
        this.onSubmit()
    },
    methods: {
        createRule() {
            this.$emit('create');
        },
        onSubmit() {
            let res_range_time = this.formInline.range_time ? this.formInline.range_time.join('/') : ''; //时间的格式处理
            let res_group_ids = this.formInline.group_id.map(item=>{
                return item.join('-')
            })
            let post_obj = {...this.formInline, range_time: res_range_time,group_id: res_group_ids, pn:this.currentPage, rn:this.pageSize}
            this.fetchList(post_obj)
        },
        resetForm() {
            this.$refs['formInline'].resetFields();
            this.formInline.range_time = [dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")]
            this.formInline.group_id = []
            this.$refs.cascaderAall.choiceEle = []
            this.onSubmit()
        },
        handleGroupId(val) {
            this.formInline.group_id = val
        },
        handleRunPush(row, path, text) {
            if(!row.managed_number) return
            if(text == '' || text == 0) {
                this.$message.error('记录为零，无法跳转');
                return;
            }
            let date = dayjs(row.create_time).format("YYYY-MM-DD");
            this.$emit('changePage', path, {id:row.managed_run_number,record_time:date});
        },
        showRunDetail(row){
            console.log('showRunDetail',row,runRecordDetailModal);
            runRecordDetailModal({
                props: {
                    platId: row.plat_id,
                    runRecordId: row.run_record_id,
                    data:{...row},
                },
            })
        },
        // 获取下拉筛选
        fetchOptions(type, el) {
            API.getManagedGetSearchList({search_type: type}).then(res=>{
                try {
                    if(type == 'group') {
                        this[el] = this.modifyIdsToValues(res.data)
                    }else{
                        this[el] = res.data
                    }
                } catch (err) {
                    console.error(err)
                }
            },err=>{
                this.$message.error(err.info);
            })
        },
        modifyIdsToValues(arr) {
            return arr.map(obj => {
                const newObj = { ...obj };
                if (newObj.children && newObj.children.length > 0) {
                    newObj.children = this.modifyIdsToValues(newObj.children);
                }
                if (newObj.hasOwnProperty('id')) {
                    newObj.value = newObj.id;
                    newObj.label = newObj.name
                    delete newObj.id;
                    delete newObj.name;
                }

                return newObj;
            });
        },
        // 列表查询
        fetchList(params) {
            this.loading = true
            API.postManagedGetList(params).then(res=>{
                this.tableData= res.data.list
                this.total = res.data.totalCnt
                this.loading = false
            }, err => {
                this.$message.error(err.info);
                this.loading = false
            })
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            this.onSubmit()
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            this.onSubmit()
        },
    },
}
</script>

<style lang="scss" scoped>
// .list-page-wrap{
//     min-height:  calc(100vh - 110px);
// }
.from_design {
    background-color: #fff;
    border-radius: 5px;

    .el-input-group__prepend {
        background-color: #fff;
    }
}
</style>

<style lang="scss">
// .list-page-wrap{
//     min-height:  calc(100vh - 110px);
// }
.bg-white {
    background-color: #fff;
}

.borderRadius5 {
    border-radius: 5px;
}

.from_design {
    padding: 0 10px 10px 10px;

    .mb0 {
        margin-bottom: 0;
    }

    .el-input-group__prepend {
        background-color: #fff;
        padding-left: 6px;
        padding-right: 6px;
        position: relative;
        color: #5a5a5a;

        &:after {
            position: absolute;
            content: "";
            width: 1px;
            height: 14px;
            background-color: #5a5a5a;
            display: block;
            z-index: 9;
            right: -1px;
            top: 6px;
        }
    }

    // .el-input--suffix .el-input__inner{
    //     padding-left: 8px;
    // }
    .el-input-group--prepend .el-input__inner {
        border-left: none;
    }

    .el-input-group__prepend .el-select {
        margin-left: 0;
        margin-right: 0;
    }

    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
        margin-bottom: 0px;
        margin-top: 10px;
    }

    .clever-form-item {
        -webkit-appearance: none;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        box-sizing: border-box;
        display: inline-block;
        outline: 0;
        padding: 0 0 0 15px;
        background-color: #fff;

        display: flex;
        align-items: center;

        .prefix {
            position: relative;
            font-size: 12px;

            .text {
                padding-right: 10px;
                color: #333;
            }

            &:after {
                position: absolute;
                content: "";
                width: 1px;
                height: 14px;
                background-color: #5a5a5a;
                display: block;
                z-index: 9;
                right: 0px;
                top: 7px;
                transform: scale(0.8);
            }

            .el-input--suffix .el-input__inner {
                padding-left: 0px;

                &::placeholder {
                    color: #333;
                }
            }
        }

        .el-input__inner {
            border: none;
        }

    }
}
</style>
